export const fieldConstants = {
  GET_FIELD_STARTED: 'GET_FIELD_STARTED',
  GET_FIELD_SUCCESS: 'GET_FIELD_SUCCESS',
  GET_FIELD_FAILURE: 'GET_FIELD_FAILURE',
};
